export default {
  auth: {
    email: 'admin@karnith.com',
    password: 'karnith2024'
  }
};